import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import clsx from "clsx";

// @material-ui/core components
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Badge,
  Box,
  FormLabel,
  Grid,
  IconButton,
  makeStyles,
} from "@material-ui/core";

// @material-ui/icons components
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import FileCopyIcon from "@material-ui/icons/FileCopy";

// core components
import MaskAndValid from "utils/maskAndValid";
import componentStylesBadge from "assets/theme/components/badge.js";
import UtilsFncs from "utils/UtilsFncs";

const useStylesTimeline = makeStyles((theme) => ({
  timeline: {
    position: "relative",
    "&:before": {
      [theme.breakpoints.up("md")]: {
        left: "50%",
      },
      borderRightStyle: "dashed",
      borderRightColor: "#FEA9B0",
      content: "''",
      position: "absolute",
      top: 0,
      left: "3rem",
      height: "100%",
      borderRight: "2px solid " + theme.palette.gray[200],
    },
  },
  timelineOneSide: {
    paddingLeft: "0.7rem",
    borderRadius: "1rem",
    width: "fit-content",
    "&:before": {
      left: "1.5rem",
    },
    "& $timelineContent": {
      width: "auto",
      [theme.breakpoints.up("md")]: {
        maxWidth: "30rem",
      },
    },
    "& $timelineBadgeRoot": {
      [theme.breakpoints.up("md")]: {
        left: "-2px",
      },
    },
    "& $timelineBlock": {
      "&:nth-child(2n) $timelineContent": {
        float: "none",
      },
    },
  },
  timelineBlock: {
    position: "relative",
    margin: "2rem 0",
    "&:first-child": {
      marginTop: 0,
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "&:after": {
      content: "''",
      display: "table",
      clear: "both",
    },
    "&:nth-child(2n) $timelineContent": {
      float: "right",
    },
  },
  timelineBadgeRoot: {
    position: "absolute",
    [theme.breakpoints.up("md")]: {
      left: "47.5%",
    },
  },
  timelineBadge: {
    width: "33px",
    height: "33px",
    borderRadius: "50%",
    display: "inline-flex",
    backgroundColor: "#FEA9B0",
  },
  pastTimelineSpots: {
    backgroundColor: "RGBA(255, 193, 197)",
  },
  timelineContent: {
    maxWidth: "max-content !important",
    marginLeft: "60px",
    paddingTop: ".5rem",
    position: "relative",
    top: " -6px",
    [theme.breakpoints.up("md")]: {
      width: "38%",
    },
  },
  typographyH5: {
    marginBottom: 0,
    marginTop: "1rem",
  },
  badgeMargin: {
    "&:not(:last-child)": {
      marginRight: ".5rem!important",
    },
  },
}));

const useStylesBadge = makeStyles(componentStylesBadge);
const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

export default function OccurencesDialog({ data, handleClose, dialogTitle }) {
  const occurrencesRef = React.useRef(null);
  const classes = {
    ...useStyles(),
    ...useStylesTimeline(),
    ...useStylesBadge(),
  };

  function formtDate(dataString) {
    const data = new Date(dataString);
    data.setMinutes(data.getMinutes() + data.getTimezoneOffset());
    return data;
  }

  return data ? (
    <Dialog open={Boolean(data)} onClose={handleClose} maxWidth="lg">
      <DialogTitle disableTypography id="alert-dialog-title">
        <Typography variant="h2" component="h2">
          {dialogTitle}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <PerfectScrollbar containerRef={() => occurrencesRef}>
        <DialogContent
          ref={occurrencesRef}
          style={{ padding: "0 1.5rem 1.5rem" }}
        >
          <Typography variant="h3">Informações de transporte</Typography>
          <br />
          <Grid container style={{ marginLeft: 0, marginRight: 0 }}>
            <Grid item xs={6}>
              <FormLabel>Nome da transportadora</FormLabel>
              <Typography variant="body2">{data.NomeTransportadora}</Typography>
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Quantidade de volumes</FormLabel>
              <Typography variant="body2">{data.QtdVolumesNf}</Typography>
            </Grid>
          </Grid>
          <br />
          <Grid container style={{ marginLeft: 0, marginRight: 0 }}>
            <Grid item xs={6}>
              <FormLabel>CNPJ</FormLabel>
              <Typography variant="body2">
                {MaskAndValid.maskCNPJ(data.CnpjTransportadora)}
                <IconButton
                  style={{ marginLeft: 5, marginBottom: 1 }}
                  title="Copiar"
                  size="small"
                  onClick={() => {
                    UtilsFncs.CopyToClipboard(
                      MaskAndValid.maskCNPJ(data.CnpjTransportadora)
                    );
                  }}
                >
                  <FileCopyIcon fontSize="large" />
                </IconButton>
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Peso bruto</FormLabel>
              <Typography variant="body2">
                {MaskAndValid.maskPrice(data.PesoBrutoTotal)} kg
              </Typography>
            </Grid>
          </Grid>
          <br />
          <Grid container style={{ marginLeft: 0, marginRight: 0 }}>
            <Grid item xs={6}>
              <FormLabel>Previsão de entrega</FormLabel>
              <Typography variant="body2">
                {data.DataPrevisaoEntrega
                  ? MaskAndValid.formattDateBR(
                      formtDate(data.DataPrevisaoEntrega)
                    )
                  : "-"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Data de Entrega</FormLabel>
              <Typography variant="body2">
                {data.DataEntrega
                  ? MaskAndValid.formattDateBR(data.DataEntrega)
                  : "-"}
              </Typography>
            </Grid>
          </Grid>
          <br />
          {data.Ocorrencias?.length > 0 ? (
            <>
              <br />
              <Typography variant="h3">Ocorrências de entrega</Typography>
              <br />
              <div className={clsx(classes.timeline, classes.timelineOneSide)}>
                {data.Ocorrencias?.map((ocorrencia, key) => (
                  <div key={key} className={classes.timelineBlock}>
                    <Badge
                      badgeContent={
                        key === 0 && data.Entregue ? (
                          <CheckIcon />
                        ) : (
                          <LocalShippingIcon />
                        )
                      }
                      classes={{
                        root: classes.timelineBadgeRoot,
                        badge: clsx(
                          classes.timelineBadge,
                          classes.badgePositionRelative,
                          { [classes.pastTimelineSpots]: key !== 0 }
                        ),
                      }}
                    ></Badge>
                    <div className={classes.timelineContent}>
                      <Box component="small" fontSize="80%" fontWeight="600">
                        {ocorrencia.DataOcorrencia.includes("T00:00:00")
                          ? MaskAndValid.formattDateBR(
                              ocorrencia.DataOcorrencia
                            )
                          : MaskAndValid.formattDateHourBR(
                              ocorrencia.DataOcorrencia
                            )}
                      </Box>
                      <Typography
                        component="h5"
                        variant="h5"
                        className={classes.typographyH5}
                      >
                        {ocorrencia.NomeOcorrencia}
                      </Typography>
                      <Box
                        component="p"
                        marginBottom="0"
                        fontWeight="300"
                        lineHeight="1.7"
                        fontSize=".875rem"
                        marginTop=".5rem"
                      >
                        {ocorrencia.Observacao}
                      </Box>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : null}
        </DialogContent>
      </PerfectScrollbar>
    </Dialog>
  ) : null;
}
